import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getStep } from './../../route-component';
import $ from 'jquery';
import {
    openMobilePlayerListing,
    setHighlight,
    makeCaptain,
    removePlayer,
    setTutorialCookie,
    setSubstitutionTutorialCookie,
    triggerHandlePlayerCard
} from './../../actions/FormationActions';
import {
    initiateSubstitution,
    makeSubstitution,
    cancelSubstitution,
} from './../../actions/ManageTeamActions';
import {
    canPlayerSubstitute,
    getPlayerByKeyFromTeamData,
} from "../../helper";
import common from '../../common';
import config from "../../config";
import OutsideNotifier from '../../OutsideNotifier';

class JerseyManageSubs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedJersey: null,
            playerStatusIconClicked: false
        };
        this.timeout = null;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.player.id === null) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        }
    }

    componentDidMount() {
        const that = this;
        const { showSubsOutTooltip } = this.props.player;
        const hasSubsOutTutorial = !that.props.hasSeenSubstitutionTutorial && showSubsOutTooltip;

        clearTimeout(that.timeout);
        if (hasSubsOutTutorial) {
            that.timeout = setTimeout(() => {
                that.props.setSubstitutionTutorialCookie();
                that.setState({ selectedJersey: null });
            }, 5000);
        }
    }

    componentDidUpdate() {
        const that = this;
        const { showSubsOutTooltip } = this.props.player;
        const hasSubsOutTutorial = !that.props.hasSeenSubstitutionTutorial && showSubsOutTooltip;

        if (hasSubsOutTutorial) {
            clearTimeout(that.timeout);
            that.timeout = setTimeout(() => {
                that.props.setSubstitutionTutorialCookie();
                that.setState({ selectedJersey: null });
            }, 5000);
        }
    }

    onPlayerStatusIconClicked = (e, player) => {
        e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        } else {
            this.setState({ selectedJersey: player.id, playerStatusIconClicked: true });
        }
    };
    onJerseyClick = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        if (this.state.playerStatusIconClicked) {
            this.setState({ playerStatusIconClicked: false });
        }
        if (player.id === null) {
            this.props.setHighlight({ player, objKey, playerIndex });
            if (config.isMobile) {
                if (!this.props.mobilePlayerListingOpen) {
                    this.props.openMobilePlayerListing(true);
                }
            }
        } else {
            this.setState({ selectedJersey: player.id });
            this.onJerseyTapToAnimate(e);
        }
    };
    onFocusLost = () => {
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };
    onFocusLostSubsOutWarningTooltip = () => {
        this.props.setSubstitutionTutorialCookie(true);
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };
    onInfoTap = (e, player) => {
        e.stopPropagation();
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        if (player && Object.keys(player).length) {
        } else {
        }
    };
    onMakeCaptainTap = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.props.makeCaptain({ player, objKey, playerIndex });
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    };
    onRevertPlayer = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.props.removePlayer({ player, objKey, playerIndex });
    };
    canSubstitute = (player) => {
        const substituteThisPlyr = canPlayerSubstitute(player);
        return substituteThisPlyr;
    };
    onInitiateSubstitution = (e, player) => {
        e.stopPropagation();
        // this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        // this.props.initiateSubstitution(player);
        this.props.triggerHandlePlayerCard(true, player.details, player)
    };

    componentWillUnmount() {
        clearTimeout(this.timeout);
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
    }

    onRemoveTap = (e, player, objKey, playerIndex) => {
        e.stopPropagation();
        this.setState({ selectedJersey: null, playerStatusIconClicked: false });
        this.props.removePlayer({ player, objKey, playerIndex });
    };
    animateView = (target) => {
        if (target.length === 0) return;
        const BUFFER = 30;
        const topValue = $(target).offset().top - $('.si-actions-strip-sticky').height() - ($('.si-actions-tooltip').outerHeight() || 0) - BUFFER;
        $('html,body').animate({
            scrollTop: topValue
        }, 500);
    };
    onJerseyTapToAnimate = (e) => {
        if (this.props.mobilePlayerListingOpen) {
            const tooltipElem = $(e.target).closest('.si-plyr-wrap');
            setTimeout(() => {
                (config.isMobile) && this.animateView(tooltipElem);
            }, 0);
        }
    };
    getTooltipMarkup = (player, tooltipClass, objKey, playerIndex) => {
        const { isCaptain, isBench } = player;
        let captainMarkup = (!isBench && !isCaptain) ?
            <span
                onClick={ (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex) }>{ this.props.trans['captain'] }</span>
            : null;
        return <div className={ "si-tooltip si-actions-tooltip " + tooltipClass + " si-flexBox" }>
            <span onClick={ (e) => this.onInfoTap(e, player.details) }>{ this.props.trans.info }</span>
            { captainMarkup }
            <span
                onClick={ (e) => this.onRemoveTap(e, player.details, objKey, playerIndex) }>{ this.props.trans.remove }</span>
        </div>
    };
    onMakeSubstitution = (e, player) => {
        this.props.triggerHandlePlayerCard(true, player.details, player)
        // this.props.makeSubstitution(player)
    };
    onCancelSubstitution = (e, player) => {
        this.props.triggerHandlePlayerCard(true, player.details, player)
        // this.props.cancelSubstitution();
    };

    hasAnyPlayedPlayerSubsOut = (e) => {
        const teamData = this.props.teamData;
        const subsOut = getPlayerByKeyFromTeamData(teamData, 'showSubsOutTooltip', true);
        return (Object.keys(subsOut).length > 0);
    }

    render() {
        const location = this.props.location;
        const teamData = this.props.teamData;
        const player = this.props.player;
        const { IsFixtureUpdated } = this.props.constraints;
        const isFixtureUpdated = (IsFixtureUpdated === 1 || IsFixtureUpdated === "1");
        const objKey = this.props.objKey;
        const isLast = this.props.position;
        const playerIndex = this.props.index;
        const { id, isHighlighted, isCaptain, details, DBDetails, skill, couldBeUsedToReplace, toBeSubstituted, isBench, substituted, showSubsOutTooltip } = player;
        const { substitutionInitiated } = teamData;
        const selectedJersey = this.state.selectedJersey;
        const currentStep = getStep(location.pathname);
        const isPlayerSelected = selectedJersey === id;
        const showIconTooltip = isPlayerSelected && this.state.playerStatusIconClicked;
        const subsOutWarningTooltip = !substitutionInitiated && showSubsOutTooltip && !this.props.hasSeenSubstitutionTutorial;
        const hasAnyPlayedPlayerSubsOut = this.hasAnyPlayedPlayerSubsOut();
        const canBeSubstitute = this.canSubstitute(player);
        const dataWrapClass = common.makeClasses({
            'si-data-wrap': true,
            'si-more-opts': subsOutWarningTooltip
        });
        const tutorialFirstTime = !this.props.hasSeenTutorial;
        const teamImg = config.playerImgBase + `player-jersey/${(details.Skill === 1) ? 'GK/' : ''}${details['TID']}.png`;
        const tutorialTooltip = <OutsideNotifier handler={ this.props.setTutorialCookie.bind(this) }>
            <div className="si-tooltip si-pick-tooltip">
                <span>{ this.props.trans['pick_your'] }</span>
            </div>
        </OutsideNotifier>;
        let isDisabled = false;
        if (substitutionInitiated) {
            if ((!toBeSubstituted && !couldBeUsedToReplace) || !canBeSubstitute) {
                isDisabled = true;
            }
        } else if (!canBeSubstitute) {
            isDisabled = true;
        }
        const jerseyClassName = common.makeClasses({
            'si-plyr-wrap': true,
            // 'si-current'  : config.isMobile ? (isHighlighted && this.props.mobilePlayerListingOpen) : isHighlighted,
            // 'si-tutorial' : isHighlighted && tutorialFirstTime,
            'si-selected': true,
            'si-disabled-plyr': isDisabled,
            'si-switched': substituted,
            'si-switch-class': toBeSubstituted
        });
        let iconClass = common.makeClasses({
            'si-subs-out-icon icon-ucl-substitute-out': !substituted && !isBench,
            'si-subs-out-icon icon-ucl-transfers-one': substituted && !isBench,
            'si-subs-in-icon icon-ucl-substitute-in': isBench
        });
        let playerTooltipText = ""
        if (!substituted && !isBench) {
            playerTooltipText = this.props.trans['subOut'] || "Sub out"
        }
        else if (isBench) {
            playerTooltipText = this.props.trans['subIn'] || "Sub in"
        }
        else if (substituted && !isBench) {
            playerTooltipText = this.props.trans['substituted'] || "Substituted"
        }

        //always keep it blank
        // playerTooltipText = ""

        let clickHandler = {
            onClick: () => {
            }
        };
        const isCreateTeamStep = currentStep === 0;
        if (isCreateTeamStep && tutorialFirstTime) {
            clickHandler = { onClick: this.props.setTutorialCookie.bind(this) };
        } else if (isCreateTeamStep) {
            if (config.isMobile) {
                if (!isDisabled) {
                    clickHandler = { onClick: (e) => this.onJerseyClick(e, player, objKey, playerIndex) };
                }
            } else {
                clickHandler = { onClick: (e) => this.onInfoTap(e, details) };
            }
        } else if (!isCreateTeamStep) {
            clickHandler = { onClick: (e) => this.onMakeCaptainTap(e, player, objKey, playerIndex) };
        }
        if (!isDisabled) {
            clickHandler = { onClick: (e) => this.onInitiateSubstitution(e, player) };
        }
        let subPos = isBench ? <div className="si-subs-pos">
            <span>{ playerIndex > 0 ? (playerIndex + '.') : null } { this.props.trans['short' + skill] }</span>
        </div> : null;
        if (id === null) {
            return <div
                className={ jerseyClassName }
                { ...clickHandler }>
                <div className="si-data-wrap">
                    <span onClick={ (e) => this.onRevertPlayer(e, DBDetails, objKey, playerIndex) }>Revert</span>
                    <span className="si-img-wrap" />
                    { !isDisabled ? <span className="si-icons">
                        <i className={ iconClass } />
                    </span> : null }
                    { (isHighlighted && tutorialFirstTime) ? tutorialTooltip : null }
                    <div className="si-plyr-pos">{ this.props.trans['short' + skill] }</div>
                    <div className="si-plyr-details">
                        <span className="si-plyr-name">TEST</span>
                        <span className="si-plyr-val">0m</span>
                    </div>
                    { subPos }
                </div>
            </div>
        } else {
            let pStatus = player.details.PStatus;
            let pStatusObj = config.playerStatusObj ? config.playerStatusObj : {};
            let pStatusHeaderClass = pStatusObj[pStatus] ? pStatusObj[pStatus]["playerInfoHeaderClass"] : '';
            // if (viewState === config.possibleActions["live"] || viewState === config.possibleActions["viewpoint"]) {
            //     pStatusHeaderClass = "";
            // }
            let hasStatus = pStatusHeaderClass !== '';
            let playerStatusIcon = null;
            if (hasStatus) {
                let pStatusTransKey = pStatusObj[pStatus] ? pStatusObj[pStatus]["transKey"] : '';
                let jerseyClassObj = {
                    'si-active': showIconTooltip
                };
                jerseyClassObj[pStatusObj[pStatus]["playerJesreyClass"]] = true;
                jerseyClassObj[pStatusHeaderClass] = true;
                const jerseyStatusIconClass = common.makeClasses(jerseyClassObj);
                playerStatusIcon =
                    <div className={ jerseyStatusIconClass } onClick={ (e) => this.onPlayerStatusIconClicked(e, player) }>
                        <span className="si-status-icon" >
                            <div className="si-tooltip si-status-tooltip si-left-tt">
                                <span>
                                    { this.props.trans[pStatusObj[pStatus]['toolTipTrans']] || pStatusObj[pStatus]['status'] }
                                </span>
                            </div>
                        </span>
                        { showIconTooltip ? <OutsideNotifier handler={ () => this.onFocusLost() }>
                            <div className="si-tooltip si-status-tooltip si-left-tt">
                                <span>{ this.props.trans[pStatusTransKey] }</span>
                            </div>
                        </OutsideNotifier> : null }
                    </div>
            }

            if (!this.props.hasSeenSubstitutionTutorial && hasAnyPlayedPlayerSubsOut) {
                clickHandler = { onClick: (e) => this.onFocusLostSubsOutWarningTooltip(e) };
            } else if (canBeSubstitute) {
                if (couldBeUsedToReplace) {
                    clickHandler = { onClick: (e) => this.onMakeSubstitution(e, player) };
                } else if (toBeSubstituted) {
                    if (substitutionInitiated) {
                        clickHandler = { onClick: (e) => this.onCancelSubstitution(e, player) };
                    } else {
                        clickHandler = { onClick: (e) => this.onInitiateSubstitution(e, player) };
                    }
                }
            }

            const captainClass = isCaptain ? 'si-captain-icon' : '';
            const tooltipClass = isLast && 'si-' + isLast + '-tt';
            let priceStrip = <div className="si-plyr-val">
                <span className="si-currency-font">€</span>
                <span>{ player.details.Value }{ this.props.trans.million }</span>
            </div>;
            const UpComingMatchesList = player.details && player.details['UpComingMatchesList'] ? player.details['UpComingMatchesList'] : [];
            let vsObj = {};
            let vsTeam = '';
            if (UpComingMatchesList.length > 0) {
                vsObj = UpComingMatchesList[0];
            }
            if (vsObj.hasOwnProperty('VsCCode')) {
                vsTeam = vsObj['VsCCode'];
            }

            let homeAwayIndctr = "";
            if (vsObj.hasOwnProperty('TLoc') && vsObj['TLoc'] != "" && vsObj['TLoc'] != null && vsObj['TLoc'] != undefined && vsObj['TLoc'] != "undefined") {
                homeAwayIndctr = "(" + vsObj['TLoc'] + ")"
            }

            let vsStrip = <div className="si-plyr-val si-sml-fonts">
                <span>{ this.props.trans.vs_short } </span>
                <span className="si-vsStrip">{ vsTeam }{ homeAwayIndctr ? " " + homeAwayIndctr + " " : "" }</span>
            </div>;

            const TPoints = player.DBDetails.OverallPoints;
            const hasPoints = !(TPoints === undefined || TPoints === null || TPoints === "");
            if (hasPoints) {
                const playerPointClasses = common.makeClasses({
                    "si-plyr-val": true,
                    "si-invalid-pts": isBench,
                    "si-minus-pts": !isBench && TPoints < 0,
                    "si-final-pts": !isBench && TPoints >= 0,
                });
                vsStrip = <div className={ playerPointClasses }>
                    { TPoints + ' ' + this.props.trans.labelPts }
                </div>;
            }

            let playerBottomStrip = (isFixtureUpdated) ? vsStrip : priceStrip;
            // playerBottomStrip = priceStrip;  // price strip each time (TBD with Harsh)
            return <div className={ jerseyClassName }
                { ...clickHandler } data-skill={ player.skill } data-id={ player.id } >
                <div className={ dataWrapClass }>
                    { playerStatusIcon }
                    <span className={ "si-img-wrap " + captainClass } style={ { backgroundImage: "url(" + teamImg + ")" } } />
                    { !isDisabled ? <span className="si-icons">
                        <i className={ iconClass } >
                            <div className="si-tooltip si-status-tooltip si-right-tt">
                                <span>{ playerTooltipText }</span>
                            </div>
                        </i>
                    </span> : null }
                    { subsOutWarningTooltip ?
                        <OutsideNotifier handler={ (e) => this.onFocusLostSubsOutWarningTooltip(e) }>
                            <div className={ "si-tooltip si-captain-tooltip si-subsOut-tooltip si-flexBox " + tooltipClass }>
                                <span>{ this.props.trans['substituteTeamTutorial'] }</span>
                            </div>
                        </OutsideNotifier> : null }
                    <div className="si-plyr-pos">{ this.props.trans['short' + skill] }</div>
                    <div className="si-plyr-details">
                        <span className="si-plyr-name">{ details['PDName'] }</span>
                        { playerBottomStrip }
                    </div>
                    { subPos }
                </div>
            </div>
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        constraints: state.appData.constraints,
        mobilePlayerListingOpen: state.formationData.mobilePlayerListingOpen,
        hasSeenTutorial: state.formationData.hasSeenTutorial,
        teamData: state.formationData.teamData,
        hasSeenSubstitutionTutorial: state.formationData.hasSeenSubstitutionTutorial,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        openMobilePlayerListing: (bool) => dispatch(openMobilePlayerListing(bool)),
        setHighlight: (obj) => dispatch(setHighlight(obj)),
        makeCaptain: (obj, objKey, playerIndex) => dispatch(makeCaptain(obj, objKey, playerIndex)),
        removePlayer: (obj) => dispatch(removePlayer(obj)),
        setTutorialCookie: () => dispatch(setTutorialCookie()),
        initiateSubstitution: (player) => dispatch(initiateSubstitution(player)),
        makeSubstitution: (player) => dispatch(makeSubstitution(player)),
        cancelSubstitution: () => dispatch(cancelSubstitution()),
        setSubstitutionTutorialCookie: (isRemove) => dispatch(setSubstitutionTutorialCookie(isRemove)),
        triggerHandlePlayerCard: (isPlayerCardVisible, playerObj, player) => dispatch(triggerHandlePlayerCard(isPlayerCardVisible, playerObj, player)),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JerseyManageSubs));


// WEBPACK FOOTER //
// ./src/components/manage-team/Jersey-ManageTeam-Substitution.js